import React from 'react';
import { Portal, Snackbar } from 'react-native-paper';
import { white } from '../styles/colors';
import { ZIndex } from '../styles/constants';
import { green, red } from '../styles/colors';
import useIsDesktop from '../hooks/useIsDesktop';

export interface SnackBarProps {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
}

export const initialSnackBarState: SnackBarProps = {
  open: false,
  message: '',
  severity: 'success',
};

const SnackBar = ({
  visible,
  onDismiss,
  message,
  severity = 'success',
  hasNavBar = true,
}: {
  visible: boolean;
  onDismiss: () => void;
  message: string;
  severity?: 'success' | 'error' | 'info' | 'warning';
  hasNavBar?: boolean;
}) => {
  const getBackgroundColor = () => {
    switch (severity) {
      case 'success':
        return green;
      case 'error':
        return red;
      default:
        return green;
    }
  };

  const isDesktop = useIsDesktop();
  const mobileBottom = hasNavBar ? 90 : 35;

  return (
    <Portal>
      <Snackbar
        visible={visible}
        onDismiss={onDismiss}
        action={{
          label: 'Close',
          onPress: onDismiss,
          textColor: white,
        }}
        wrapperStyle={{
          width: isDesktop ? 320 : '100%',
          paddingHorizontal: 10,
          marginHorizontal: 10,
        }}
        style={{
          width: '100%',
          margin: 0,
          zIndex: ZIndex.TopLayer,
          backgroundColor: getBackgroundColor(),
          position: 'absolute',
          bottom: isDesktop ? 20 : mobileBottom,
        }}
      >
        {message}
      </Snackbar>
    </Portal>
  );
};

export default SnackBar;
